<template>
	<div v-if="user">
		<div v-if="user.hasPackage(1)">
			<router-view
				v-if="user.hasRole(['manager', 'admin', 'staff'])"
				:user="user"
				:isAuth="isAuth">
			</router-view>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/CmsPackage.vue